import { lazy } from "react";

export const CollectionItemsPage = lazy(() => import("pages/CollectionItemsPage/CollectionItemsPage"));
export const CollectionsPage = lazy(() => import("pages/CollectionsPage/CollectionsPage"));
export const CrashPage = lazy(() => import("pages/CrashPage/CrashPage"));
export const EmbedPage = lazy(() => import("pages/EmbedPage/EmbedPage"));
export const ExploreCreatorsPage = lazy(() => import("pages/ExploreCreatorsPage/ExploreCreatorsPage"));
export const ExploreGifsPage = lazy(() => import("pages/ExploreGifsPage/ExploreGifsPage"));
export const ExploreImagesPage = lazy(() => import("pages/ExploreImagesPage/ExploreImagesPage"));
export const ExploreNichesPage = lazy(() => import("pages/ExploreNichesPage/ExploreNichesPage"));
export const ExplorePage = lazy(() => import("pages/ExplorePage/ExplorePage"));
export const FavouritesPage = lazy(() => import("pages/FavouritesPage/FavouritesPage"));
export const SubscriptionPages = lazy(() => import("@/subscription-pages"));
export const HomePage = lazy(() => import("pages/HomePage/HomePage"));
export const ManageAdSlotsPage = lazy(() => import("pages/ManageAdSlotsPage/ManageAdSlotsPage"));
export const MigrateImgurConfirmPage = lazy(() => import("pages/Migrate/MigrateImgurConfirmPage"));
export const MigrateImgurPage = lazy(() => import("pages/Migrate/MigrateImgurPage"));
export const MigrateImgurSuccessPage = lazy(() => import("pages/Migrate/MigrateImgurSuccessPage"));
export const MyNichesPage = lazy(() => import("pages/MyNichesPage/MyNichesPage"));
export const NichePage = lazy(() => import("@/niche-page"));
export const ProfileSettingsPage = lazy(() => import("@/profile-settings-page"));
export const SearchPage = lazy(() => import("@/search-page"));
export const FreetypeSearchPage = lazy(() => import("pages/FreetypeSearchPage/FreetypeSearchPage"));
export const StaticPages = lazy(() => import("@/static-pages"));
export const SudoPage = lazy(() => import("@/sudo-page"));
export const TagPage = lazy(() => import("@/tag-page"));
export const TexasSlatePage = lazy(() => import("@/texas-slate"));
export const UnsubscribedPage = lazy(() => import("@/unsubscribed-page"));
export const UserPage = lazy(() => import("@/user-page"));
export const SearchWarningPage = lazy(() => import("pages/BannedWordSearchWarning/SearchWarningPage"));
export const SignInPage = lazy(() => import("@/signin-page"));
export const SignUpPage = lazy(() => import("@/signup-page"));
